import { Navigate, useSearchParams } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useAuthStore } from '../../../store/authStore';
import { useSendShopifyStore } from '../../../apiHooks/mutations/sendShopifyStore/sendShopifyStore';

const ShopifyPayRoute = () => {
  const { isLoggedIn } = useAuthStore();
  const [searchParams] = useSearchParams();
  const shop = searchParams.get('shop') ?? '';

  const { mutate } = useSendShopifyStore();

  useEffect(() => {
    mutate(shop);
  }, []);

  if (isLoggedIn) {
    return <Navigate to="/dashboard" />;
  }

  return <Navigate to="/auth" />;
};

export default ShopifyPayRoute;
